function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTheme, HStack, Menu, Pressable, Text } from 'native-base';
import { useEnvState } from '../../context/env';
import { useAuthState } from '../../context/auth';
import { overviewAPI, useOverviewState, useOverviewDispatch } from '../../context/overview';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faEllipsis } from '@fortawesome/pro-solid-svg-icons/faEllipsis';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import FRNMenu from '../content/common/reusables/FRNMenu';
const ContextMenu = ({
  isContextMenuOpen,
  setIsContextMenuOpen,
  id,
  read,
  selected,
  updateNotifications
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const envState = useEnvState();
  const authState = useAuthState();
  const overviewState = useOverviewState();
  const overviewDispatch = useOverviewDispatch();
  const handleOnPress = async () => {
    if (envState.base_url && authState.api_key && id) {
      const response = await overviewAPI.setActivityToRead(envState.base_url, authState.api_key, id);
      if (!response) {
        throw new Error("Couldn't mark notification as read. Please try again");
      }

      // update UI (change bg, remove blue dot)
      if (selected === 'Activity' && updateNotifications) {
        updateNotifications(id);
      }

      // update UI (deduct 1 from unreadActivityCount)
      overviewDispatch({
        type: 'SET_UNREAD_ACTIVITY_COUNT',
        payload: overviewState.unreadActivityCount - 1
      });
    }
  };
  return /*#__PURE__*/React.createElement(FRNMenu, {
    isOpen: isContextMenuOpen,
    onOpen: () => setIsContextMenuOpen(true),
    onClose: () => setIsContextMenuOpen(false),
    trigger: triggerProps => /*#__PURE__*/React.createElement(Pressable, _extends({}, triggerProps, {
      px: "2",
      py: "1",
      w: "50%",
      h: "50%",
      minW: "20px",
      minH: "20px",
      borderRadius: "xl",
      _hover: {
        bg: colors.activity.dismissal
      },
      alignItems: "center"
    }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faEllipsis,
      color: "#000",
      size: 24
    }))
  }, /*#__PURE__*/React.createElement(Menu.Item, {
    onPress: () => setIsContextMenuOpen(false),
    alignSelf: "flex-end",
    p: "0",
    right: "4",
    maxW: "24px",
    maxH: "24px"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCircleXmark,
    color: colors.activity.text,
    size: 24
  })), /*#__PURE__*/React.createElement(Menu.Item, {
    isDisabled: read,
    onPress: handleOnPress
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 4,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCheck,
    color: read ? colors.activity.readItem : colors.activity.markAsRead,
    size: 20
  }), /*#__PURE__*/React.createElement(Text, {
    color: read ? colors.activity.readItem : '#000'
  }, "Mark as read"))));
};
export default ContextMenu;
//# sourceMappingURL=ContextMenu.js.map